export enum BlfTypes {
  NOT_USED = 'notUsed',
  BLF = 'blf',
  SPEED_DIAL = 'speedDial',
  LINE = 'line',
  BLF_NO_PICKUP = 'blfNoPickup',
  EXTENSION_MOBILITY = 'extensionMobility'
}

export interface BlfDto {
  buttonNumber: number
  type: BlfTypes
  phoneNumber?: string
  guid?: string
  header?: string
  userTerminalId?: number
  mac?: string
  buttonPage: number
  // Только на фронте
  id?: string
}
